export function viewFitAllAction() {
  const { t } = useI18n();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.view_fit_all') || 'View Fit All',

    doAction: function (context) {
      context.viewer.cameraFlight.flyTo({
        aabb: context.viewer.scene.getAABB(),
      });
    },
  };
}
